export default "__VITE_ASSET__kMPM$rDD__"